import BaseCommand from "@/models/api/commands/BaseCommand";

export interface PaymentDateChangeCommandParams {
  IsFromSaleDate: boolean;
  PaymentDaysCount: null | number;
  PaymentDate: string | null;
}

export class PaymentDateChangeCommand extends BaseCommand {
  CommandName = "PaymentDateChange";
  Command: PaymentDateChangeCommandParams;
  constructor(sessionId: string, operationId: string, paymentDateParams: PaymentDateChangeCommandParams) {
    super(sessionId, operationId);
    this.Command = paymentDateParams;
  }
}
